(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-result.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.core.log.getLogger('module:lyckoplatsen');
const {
  createMap,
  mapDefaults,
  sweRectangleBounds,
  worldRectangleBounds,
  locationToArray,
  getIconLeaflet,
  disableInteraction,
  getSouthCoordinate,
  checkDuplicateWagersLocations
} = svs.tur.lyckoplatsen.map;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const formatCurrency = svs.utils.format.Currency;
function getResultMapHandler() {
  let map;
  let mapId;
  let intervalPins = [];
  let wagerPins = [];
  let singleCircles = [];
  let singelPin;
  let singleWorldRec;
  let circleIndex = 0;
  let winningCoord;
  let singleWinGroups = [];
  let mapLayers = [];
  let showCenterMapButton = false;
  let showCenterWagersButton = false;
  let maxZoom;
  let minZoom;
  let tlResult;
  let worldPath;
  const eventHandlers = {};
  const trackMapLayers = e => mapLayers.push(e.layer);

  let _isDestroying = false;

  const svgRenderer = leaflet.svg({
    padding: 0.85
  });
  return {
    createMap(_ref) {
      let {
        mapOptions = {},
        evtHandlers = {}
      } = _ref;
      Object.assign(eventHandlers, evtHandlers);
      const options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      mapId = options.nodeId;

      const el = document.getElementById(mapId);
      if (el && el._leaflet_id) {
        el._leaflet_id = null;
      }
      if (map) {
        map.remove();
        map = null;
      }
      map = createMap(options);
      maxZoom = options.maxZoom;
      minZoom = options.minZoom;
      this.handleZoomButtonsEvents();
      disableInteraction(map);
      map.on('resize', _.debounce(() => this.updateUI(circleIndex), 300));
      return map;
    },
    handleZoomButtonsEvents() {
      map.whenReady(() => {
        const mapContainer = document.getElementById(mapId);
        const zoomInButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-out');
        if (zoomInButton) {
          zoomInButton.addEventListener('click', () => {
            var _eventHandlers$highli;
            const z = map.getZoom();
            showCenterWagersButton = true;
            showCenterMapButton = true;
            map.setView(winningCoord, z + 1, {
              animate: false
            });
            (_eventHandlers$highli = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli === void 0 || _eventHandlers$highli.call(eventHandlers, 'zoomed');
            this.uiStamp(0);
          });
        }
        if (zoomOutButton) {
          zoomOutButton.addEventListener('click', () => {
            var _eventHandlers$highli2;
            const z = map.getZoom();
            showCenterWagersButton = true;
            showCenterMapButton = true;
            map.setView(winningCoord, z - 1, {
              animate: false
            });
            (_eventHandlers$highli2 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli2 === void 0 || _eventHandlers$highli2.call(eventHandlers, 'zoomed');
            this.uiStamp(0);
          });
        }
      });
    },
    fitBoundsSweden() {
      var _map;
      (_map = map) === null || _map === void 0 || _map.fitBounds(sweRectangleBounds, {
        minZoom,
        maxZoom,
        animate: false
      });
    },
    selectSinglePin() {
      var _singelPin;
      this.moveToWinGroup(singleWinGroups.length - 1);
      (_singelPin = singelPin) === null || _singelPin === void 0 || _singelPin.setIcon(getIconLeaflet({
        color: 'green'
      }));
    },
    clearSelectedSinglePin() {
      var _singelPin2;
      (_singelPin2 = singelPin) === null || _singelPin2 === void 0 || _singelPin2.setIcon(getIconLeaflet({
        color: 'blue'
      }));
    },
    removeIntervalResult() {
      intervalPins.forEach(pin => {
        var _pin$remove;
        return pin === null || pin === void 0 || (_pin$remove = pin.remove) === null || _pin$remove === void 0 ? void 0 : _pin$remove.call(pin);
      });
      intervalPins = [];
    },
    centerMap() {
      var _singleCircles$;
      showCenterMapButton = false;
      showCenterWagersButton = true;
      circleIndex = 0;
      const bounds = (_singleCircles$ = singleCircles[0]) === null || _singleCircles$ === void 0 ? void 0 : _singleCircles$.getBounds();
      if (bounds && bounds !== null && bounds !== void 0 && bounds.isValid()) {
        var _map2;
        (_map2 = map) === null || _map2 === void 0 || _map2.fitBounds(bounds, {
          animate: false,
          padding: [45, 15],
          minZoom,
          maxZoom
        });
      }
      this.updateUI();
    },
    centerWagers() {
      var _leaflet$featureGroup, _singleCircles$2;
      showCenterMapButton = true;
      showCenterWagersButton = false;
      const winningLat = Number(winningCoord[0]);
      let hasPinAbove = false;
      let hasPinBelow = false;
      wagerPins.forEach(pin => {
        const pinLat = pin.getLatLng().lat;
        if (pinLat > winningLat) {
          hasPinAbove = true;
        }
        if (pinLat < winningLat) {
          hasPinBelow = true;
        }
      });
      const bounds = leaflet.latLngBounds([(_leaflet$featureGroup = leaflet.featureGroup(wagerPins)) === null || _leaflet$featureGroup === void 0 ? void 0 : _leaflet$featureGroup.getBounds(), (_singleCircles$2 = singleCircles[0]) === null || _singleCircles$2 === void 0 ? void 0 : _singleCircles$2.getBounds()]);
      if (bounds && bounds !== null && bounds !== void 0 && bounds.isValid()) {
        var _map3;
        (_map3 = map) === null || _map3 === void 0 || _map3.fitBounds(bounds, {
          animate: false,
          paddingTopLeft: [85, hasPinAbove ? 85 : 45],
          paddingBottomRight: [85, hasPinBelow ? 85 : 15],
          minZoom,
          maxZoom
        });
      }
      this.updateUI();
    },
    updateUI() {
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.uiCenterMap();
      this.uiCenterMapWagers();
      this.uiStamp(index);
    },
    moveToWinGroup(index) {
      var _singleCircles$newInd;
      let zoomed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      let newIndex = singleCircles.length - 1 - index;
      if (index === null) {
        newIndex = 0;
      }
      const moveTo = (_singleCircles$newInd = singleCircles[newIndex]) === null || _singleCircles$newInd === void 0 ? void 0 : _singleCircles$newInd.getBounds();
      if (!moveTo) {
        return;
      }
      if (!zoomed) {
        var _map4;
        const moveToCenter = moveTo.getCenter();
        const moveToZoom = map.getBoundsZoom(moveTo);
        (_map4 = map) === null || _map4 === void 0 || _map4.setView([moveToCenter.lat, moveToCenter.lng], moveToZoom, {
          animate: false
        });
        showCenterMapButton = newIndex !== 0;
        showCenterWagersButton = true;
        this.updateUI(newIndex);
      }
    },
    showResult(_ref2) {
      let {
        winGroups,
        winningLocation,
        evtHandlers
      } = _ref2;
      map.on('layeradd', trackMapLayers);
      Object.assign(eventHandlers, evtHandlers);
      singleWinGroups = winGroups.slice().reverse();
      winningCoord = locationToArray(winningLocation);
      this.addWorldRectangle();
      this.addSingleWinPin();
      this.addSingleLabels();
      this.addSingleCircles();
      this.animateMapIn();
      map.off('layeradd', trackMapLayers);
    },
    animateMapIn() {
      tlResult = gsap.timeline();
      if (document.querySelector('.pin-heart svg')) {
        tlResult.set("#".concat(mapId, " .pin-heart svg"), {
          opacity: 0,
          height: '0px'
        });
      }
      if (document.querySelector('.gsap-heart-count')) {
        tlResult.set("#".concat(mapId, " .gsap-heart-count"), {
          opacity: 0,
          scale: 1
        });
      }
      if (document.querySelector('.result-map')) {
        tlResult.to('.result-map', {
          delay: 0.5,
          opacity: 1,
          duration: 1,
          ease: 'power1.out'
        }, '>');
      }
      if (document.querySelector('.pin-single.pin-heart svg')) {
        tlResult.to("#".concat(mapId, " .pin-single.pin-heart svg"), {
          opacity: 1,
          height: '80px',
          duration: 1.2,
          ease: 'elastic(1, 0.5)'
        });
        tlResult.to("#".concat(mapId, " .pin-single.pin-heart svg"), {
          width: '54px',
          duration: 0.9,
          ease: 'back.out(1.2)'
        }, '<');
      }
      if (document.querySelector('.pin-wager.pin-heart svg')) {
        tlResult.to("#".concat(mapId, " .pin-wager.pin-heart svg"), {
          opacity: 1,
          height: '80px',
          duration: 1.2,
          ease: 'elastic(1, 0.5)'
        });
        tlResult.to("#".concat(mapId, " .pin-wager.pin-heart svg"), {
          width: '54px',
          duration: 0.9,
          ease: 'back.out(1.2)'
        }, '>');
      }
      if (document.querySelector('.gsap-heart-count')) {
        tlResult.to("#".concat(mapId, " .gsap-heart-count"), {
          opacity: 1,
          scale: 1,
          duration: 0.375,
          ease: 'power4.out'
        }, '<');
      }
      if (document.querySelector("#".concat(mapId, " .leaflet-popup"))) {
        tlResult.to("#".concat(mapId, " .leaflet-popup"), {
          opacity: 1,
          duration: 0.5,
          delay: 0.4
        }, '<');
      }
      tlResult.play();
    },
    showWagers(wagers, result, evtHandlers) {
      Object.assign(eventHandlers, evtHandlers);
      this.addWagerPins(wagers, result);
      this.animateMapIn();
    },
    removeWagers() {
      wagerPins.forEach(pin => {
        var _pin$closePopup, _pin$remove2;
        pin === null || pin === void 0 || (_pin$closePopup = pin.closePopup) === null || _pin$closePopup === void 0 || _pin$closePopup.call(pin);
        pin === null || pin === void 0 || (_pin$remove2 = pin.remove) === null || _pin$remove2 === void 0 || _pin$remove2.call(pin);
      });
      wagerPins = [];
    },
    addWagerPins(mapWagers, result) {
      const uniqueWagersLocations = checkDuplicateWagersLocations(mapWagers);
      const wagers = uniqueWagersLocations;
      const hasMultiple = (wagers === null || wagers === void 0 ? void 0 : wagers.length) > 1;
      wagers.sort((a, b) => {
        const A = parseFloat(a.winAmount.replace(',', '.'));
        const B = parseFloat(b.winAmount.replace(',', '.'));
        return A - B;
      });
      const mappedWagers = wagers.map((wager, index) => {
        var _wager$wins, _wager$description, _wager$location;
        const heartPin = getIconLeaflet({
          color: 'red',
          className: 'pin-wager',
          count: wager.wagerMultiplayed
        });
        const wagerCoords = locationToArray(wager.wager.bets[0].geoBoardData.geoLoc);
        const pin = leaflet.marker(wagerCoords, {
          icon: heartPin,
          autoPanOnFocus: false
        });
        pin.setZIndexOffset((index + 1000) * ((wager === null || wager === void 0 ? void 0 : wager.wagerMultiplayed) || 1));
        pin.addTo(map);
        const match = wager === null || wager === void 0 || (_wager$wins = wager.wins) === null || _wager$wins === void 0 ? void 0 : _wager$wins.find(win => win.drawNumber === (result === null || result === void 0 ? void 0 : result.drawNumber) && productMapping.isSameProduct(win.productId, result === null || result === void 0 ? void 0 : result.productId));
        let text;
        if (match) {
          const val = parseFloat(match.amount.replace(',', '.'));
          text = "Vinst: <strong>".concat(wager.wagerMultiplayed ? formatCurrency(val * wager.wagerMultiplayed) : formatCurrency(val), " kr</strong>");
        } else {
          const closestCircle = result === null || result === void 0 ? void 0 : result.distribution.at(-1).distanceMeters;
          const dist = svs.lyckoplatsen.utils.format.getDistance({
            from: wagerCoords,
            to: winningCoord,
            subMeter: closestCircle
          });
          text = "".concat(dist, " fr\xE5n vinst");
        }
        const content = "<strong class=\"leaflet-popup-header\">".concat((_wager$description = wager.description) !== null && _wager$description !== void 0 ? _wager$description : (_wager$location = wager.location) === null || _wager$location === void 0 ? void 0 : _wager$location.name, "</strong>").concat(text);
        const popup = leaflet.popup({
          autoClose: hasMultiple,
          closeButton: hasMultiple,
          closeOnClick: hasMultiple,
          autoPan: false
        }).setContent(content);
        pin.bindPopup(popup);
        if (!hasMultiple) {
          pin.openPopup();
        }
        pin.off('click');
        pin.on('click', () => pin.isPopupOpen() ? pin.closePopup() : pin.openPopup());
        const pinEl = pin.getElement();
        if (pinEl) {
          pinEl.addEventListener('focus', () => {
            const bounds = map.getBounds();
            const latlng = pin.getLatLng();
            if (!bounds.contains(latlng)) {
              var _eventHandlers$highli3;
              this.centerWagers();
              (_eventHandlers$highli3 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli3 === void 0 || _eventHandlers$highli3.call(eventHandlers, null);
              this.updateUI();
            }
          });
        }
        return pin;
      });
      wagerPins = mappedWagers;
    },
    uiCenterMap() {
      var _eventHandlers$showCe;
      (_eventHandlers$showCe = eventHandlers.showCenterMapButton) === null || _eventHandlers$showCe === void 0 || _eventHandlers$showCe.call(eventHandlers, Boolean(showCenterMapButton));
    },
    uiCenterMapWagers() {
      var _eventHandlers$showCe2;
      (_eventHandlers$showCe2 = eventHandlers.showCenterWagersButton) === null || _eventHandlers$showCe2 === void 0 || _eventHandlers$showCe2.call(eventHandlers, Boolean(showCenterWagersButton));
    },
    uiStamp() {
      var _singleCircles$index, _singleWorldRec;
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      const circlePath = (_singleCircles$index = singleCircles[index]) === null || _singleCircles$index === void 0 || (_singleCircles$index = _singleCircles$index._path) === null || _singleCircles$index === void 0 ? void 0 : _singleCircles$index.getAttribute('d');
      if (circlePath && worldPath && (_singleWorldRec = singleWorldRec) !== null && _singleWorldRec !== void 0 && _singleWorldRec._path) {
        singleWorldRec._path.setAttribute('d', "".concat(worldPath, " ").concat(circlePath));
      }
    },
    addWorldRectangle() {
      var _singleWorldRec2;
      singleWorldRec = leaflet.rectangle(worldRectangleBounds, {
        fillColor: '#001E3C',
        fillOpacity: 0.72,
        stroke: false,
        className: 'world-rect',
        renderer: svgRenderer
      });
      singleWorldRec.addTo(map);
      singleWorldRec.on('click', ev => {
        var _eventHandlers$highli4;
        leaflet.DomEvent.stopPropagation(ev);
        (_eventHandlers$highli4 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli4 === void 0 || _eventHandlers$highli4.call(eventHandlers, null);
      });
      worldPath = (_singleWorldRec2 = singleWorldRec) === null || _singleWorldRec2 === void 0 || (_singleWorldRec2 = _singleWorldRec2._path) === null || _singleWorldRec2 === void 0 ? void 0 : _singleWorldRec2.getAttribute('d');
    },
    addSingleWinPin() {
      const heartPin = getIconLeaflet({
        color: 'blue',
        className: 'pin-single'
      });
      singelPin = leaflet.marker(winningCoord, {
        icon: heartPin
      });
      singelPin.addTo(map).on('click', ev => {
        var _eventHandlers$highli5;
        leaflet.DomEvent.stopPropagation(ev);
        (_eventHandlers$highli5 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli5 === void 0 || _eventHandlers$highli5.call(eventHandlers, 0);
        showCenterMapButton = true;
      }).on('keypress', ev => {
        if (ev.originalEvent.key === 'Enter') {
          var _eventHandlers$highli6;
          leaflet.DomEvent.stopPropagation(ev);
          (_eventHandlers$highli6 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli6 === void 0 || _eventHandlers$highli6.call(eventHandlers, 0);
          showCenterMapButton = true;
          showCenterWagersButton = true;
        }
      });
    },
    addSingleLabels() {
      const labels = [];
      map.createPane('labels');
      map.getPane('labels').style.zIndex = 401;
      singleWinGroups.forEach((circle, index) => {
        let labelDistance = circle.distanceMeters;
        if (singleWinGroups.length - 1 !== index) {
          labelDistance = circle.distanceMeters * 0.96;
        }
        const labelCoord = getSouthCoordinate(winningCoord, Math.trunc(labelDistance));
        const winsTxt = "".concat(formatCurrency(circle.winners), " ").concat(circle.winners === 1 ? 'vinst' : 'vinster');
        const myIcon = leaflet.divIcon({
          className: "label label-".concat(singleWinGroups.length - 1 - index, " ").concat(circle.distanceMeters < 200 ? 'label-below' : '', " "),
          html: "<div>".concat(winsTxt, " \xE0 ").concat(formatCurrency(circle.amountSek.slice(0, -3)), " kr<span>").concat(index === singleWinGroups.length - 1 ? 'Toppvinst' : svs.lyckoplatsen.utils.format.formatDistance(circle.distanceMeters), "</span></div>"),
          iconSize: [0, 0]
        });
        const leafletLabel = leaflet.marker(labelCoord, {
          icon: myIcon,
          pane: 'labels',
          keyboard: false
        });
        leafletLabel.addTo(map);
        labels.push(leafletLabel);
      });
    },
    addSingleCircles() {
      var _eventHandlers$result;
      const circles = [];
      singleWinGroups.forEach((circle, index) => {
        const newIndex = singleWinGroups.length - 1 - index; 
        const leafletCircleArea = leaflet.circle(winningCoord, {
          color: 'transparent',
          className: "stamped-area stamped-area-".concat(newIndex),
          radius: circle.distanceMeters,
          renderer: svgRenderer
        });
        leafletCircleArea.on('add', function () {
          var _path$setAttribute;
          const path = this._path;
          const tabIndex = index === 0 ? '-1' : '0';
          path === null || path === void 0 || (_path$setAttribute = path.setAttribute) === null || _path$setAttribute === void 0 || _path$setAttribute.call(path, 'tabindex', tabIndex);
        }).on('click', ev => {
          var _eventHandlers$highli7;
          leaflet.DomEvent.stopPropagation(ev);
          (_eventHandlers$highli7 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli7 === void 0 || _eventHandlers$highli7.call(eventHandlers, newIndex);
          showCenterMapButton = true;
          showCenterWagersButton = true;
        }).on('keypress', ev => {
          if (ev.originalEvent.key === 'Enter') {
            var _eventHandlers$highli8;
            leaflet.DomEvent.stopPropagation(ev);
            (_eventHandlers$highli8 = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli8 === void 0 || _eventHandlers$highli8.call(eventHandlers, newIndex);
            showCenterMapButton = true;
            showCenterWagersButton = true;
          }
        });
        leafletCircleArea.addTo(map);
        circles.push(leafletCircleArea);
      });
      singleCircles = circles;
      (_eventHandlers$result = eventHandlers.resultRendered) === null || _eventHandlers$result === void 0 || _eventHandlers$result.call(eventHandlers);
    },
    removeResult() {
      mapLayers.forEach(layer => {
        var _layer$remove;
        return layer === null || layer === void 0 || (_layer$remove = layer.remove) === null || _layer$remove === void 0 ? void 0 : _layer$remove.call(layer);
      });
      mapLayers = [];
    },
    removeMap() {
      if (_isDestroying) {
        return;
      }
      _isDestroying = true;

      try {
        if (tlResult) {
          tlResult.eventCallback('onComplete', null);
          tlResult.pause(0);
          tlResult.kill();
          tlResult = null;
        }
      } catch (_unused) {
        logger.debug('Result map, GSAP not removed properly');
      }

      try {
        var _map5;
        (_map5 = map) === null || _map5 === void 0 || _map5.off('resize');
      } catch (_unused2) {
        logger.debug('Result map, map listeners not removed properly');
      }

      try {
        var _map6, _map6$closePopup, _map7, _map7$closeTooltip, _singelPin3, _singelPin3$remove, _singleWorldRec3, _singleWorldRec3$remo;
        (_map6 = map) === null || _map6 === void 0 || (_map6$closePopup = _map6.closePopup) === null || _map6$closePopup === void 0 || _map6$closePopup.call(_map6);
        (_map7 = map) === null || _map7 === void 0 || (_map7$closeTooltip = _map7.closeTooltip) === null || _map7$closeTooltip === void 0 || _map7$closeTooltip.call(_map7);
        intervalPins.forEach(p => {
          var _p$remove;
          return p === null || p === void 0 || (_p$remove = p.remove) === null || _p$remove === void 0 ? void 0 : _p$remove.call(p);
        });
        intervalPins = [];
        wagerPins.forEach(p => {
          var _p$closePopup, _p$remove2;
          p === null || p === void 0 || (_p$closePopup = p.closePopup) === null || _p$closePopup === void 0 || _p$closePopup.call(p);
          p === null || p === void 0 || (_p$remove2 = p.remove) === null || _p$remove2 === void 0 || _p$remove2.call(p);
        });
        wagerPins = [];
        mapLayers.forEach(l => {
          var _l$remove;
          return l === null || l === void 0 || (_l$remove = l.remove) === null || _l$remove === void 0 ? void 0 : _l$remove.call(l);
        });
        mapLayers = [];
        (_singelPin3 = singelPin) === null || _singelPin3 === void 0 || (_singelPin3$remove = _singelPin3.remove) === null || _singelPin3$remove === void 0 || _singelPin3$remove.call(_singelPin3);
        singelPin = null;
        (_singleWorldRec3 = singleWorldRec) === null || _singleWorldRec3 === void 0 || (_singleWorldRec3$remo = _singleWorldRec3.remove) === null || _singleWorldRec3$remo === void 0 || _singleWorldRec3$remo.call(_singleWorldRec3);
        singleWorldRec = null;
        singleCircles.forEach(c => {
          var _c$remove;
          return c === null || c === void 0 || (_c$remove = c.remove) === null || _c$remove === void 0 ? void 0 : _c$remove.call(c);
        });
        singleCircles = [];
      } catch (_unused3) {
        logger.debug('Result map, tracked layers/markers not removed properly');
      }

      try {
        const container = document.getElementById(mapId);
        container === null || container === void 0 || container.querySelectorAll('.world-rect, .pin-wager, .pin-single, .label, .stamped-area, .gsap-heart-count').forEach(el => el.remove());
      } catch (_unused4) {
        logger.debug('Result map, dom elements removed properly');
      }

      try {
        if (map) {
          var _map$stop, _map8;
          (_map$stop = (_map8 = map).stop) === null || _map$stop === void 0 || _map$stop.call(_map8);
          map.off();
          map.remove();
          map = null;
        }
      } catch (_unused5) {
        logger.debug('Result map, the map is not removed properly');
      }

      mapId = null;
      singleWinGroups = [];
      circleIndex = 0;
      winningCoord = null;
      showCenterMapButton = false;
      showCenterWagersButton = false;
      _isDestroying = false;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getResultMapHandler
});

 })(window);